import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

export const StarRating = ({ rating, size = 'default', interactive = false, onChange }) => {
  const sizeClasses = {
    small: 'w-3 h-3',
    default: 'w-4 h-4',
    large: 'w-5 h-5',
  };

  const handleClick = (value) => {
    if (interactive && onChange) {
      onChange(value);
    }
  };

  return (
    <div className="flex items-center gap-0.5" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((value) => (
        <button
          key={value}
          type="button"
          onClick={() => handleClick(value)}
          disabled={!interactive}
          className={cn(
            'transition-transform',
            interactive && 'hover:scale-110 cursor-pointer',
            !interactive && 'cursor-default'
          )}
          data-testid={`star-${value}`}
        >
          <Star
            className={cn(
              sizeClasses[size],
              value <= rating ? 'fill-amber-400 text-amber-400' : 'fill-transparent text-zinc-600'
            )}
          />
        </button>
      ))}
    </div>
  );
};

export default StarRating;
